/* CUSTOM: Size finder, works with Gain, Xclusive and most Online Store 2.0 themes */
(function () {
	'use strict';
	if (window.__sizeFinderLoaded) return;
	window.__sizeFinderLoaded = true;

	var last = { h: '', w: '' }; /* keeps typed values if the theme re-renders the product */

	function each(list, fn) { Array.prototype.forEach.call(list || [], fn); }
	function norm(v) {
		v = String(v == null ? '' : v).toUpperCase().replace(/\s+/g, '');
		return v.replace(/^XXXXXL$/, '5XL').replace(/^XXXXL$/, '4XL').replace(/^XXXL$/, '3XL').replace(/^XXL$/, '2XL');
	}
	function fmt(str, map) {
		return String(str || '').replace(/\{(\w+)\}/g, function (m, k) { return map[k] != null ? map[k] : m; });
	}
	function esc(s) {
		var d = document.createElement('div');
		d.textContent = String(s == null ? '' : s);
		return d.innerHTML;
	}
	function bold(s) { return '<b>' + esc(s) + '</b>'; }
	function readJSON(root, sel) {
		var el = root.querySelector(sel);
		try { return el ? JSON.parse(el.textContent) : null; } catch (e) { return null; }
	}

	function init(root) {
		if (root._sf) return;
		root._sf = true;

		var chart = readJSON(root, '[data-sf-chart]') || [];
		var optionNames = readJSON(root, '[data-sf-options]') || [];
		var optionValues = readJSON(root, '[data-sf-values]') || [];
		var variants = readJSON(root, '[data-sf-variants]') || [];
		var t = readJSON(root, '[data-sf-text]') || {};
		var pos = parseInt(root.getAttribute('data-size-position'), 10) || 0;
		var shortH = parseInt(root.getAttribute('data-short-height'), 10) || 0;
		var scope = root.closest('.shopify-section') || document;

		var hI = root.querySelector('[data-sf-h]');
		var wI = root.querySelector('[data-sf-w]');
		var res = root.querySelector('[data-sf-res]');
		var wa = root.querySelector('[data-sf-wa]');
		var hint = root.querySelector('[data-sf-hint]');
		var rows = root.querySelectorAll('[data-sf-row]');

		/* EDIT 1: height input is optional now */
		if (!pos || !chart.length || !wI) return;

		/* EDIT 2: only restore height if the field exists */
		if (last.h && hI) hI.value = last.h;
		if (last.w) wI.value = last.w;

		/* Find the inputs/selects for option i in any theme */
		function controlsFor(i) {
			/* Gain: name="option1", "option2"... */
			var direct = scope.querySelectorAll('input[name="option' + i + '"], select[name="option' + i + '"]');
			if (direct.length) return Array.prototype.slice.call(direct);

			/* Other themes: match by the option's real values */
			var vals = optionValues[i - 1] || [];
			var name = String(optionNames[i - 1] || '').toLowerCase();
			var best = [], bestScore = 0, groups = {};

			each(scope.querySelectorAll('input[type="radio"]'), function (r) {
				if (vals.indexOf(r.value) === -1) return;
				(groups[r.name] = groups[r.name] || []).push(r);
			});
			Object.keys(groups).forEach(function (n) {
				var score = groups[n].length + (name && n.toLowerCase().indexOf(name) > -1 ? 1000 : 0);
				if (score > bestScore) { bestScore = score; best = groups[n]; }
			});
			each(scope.querySelectorAll('select'), function (s) {
				var hits = 0;
				each(s.options, function (o) { if (vals.indexOf(o.value) > -1) hits++; });
				if (!hits) return;
				var score = hits + (name && (s.name || '').toLowerCase().indexOf(name) > -1 ? 1000 : 0);
				if (score > bestScore) { bestScore = score; best = [s]; }
			});
			return best;
		}

		function currentValue(i) {
			var list = controlsFor(i);
			for (var k = 0; k < list.length; k++) {
				if (list[k].tagName === 'SELECT') return list[k].value;
				if (list[k].checked) return list[k].value;
			}
			return null;
		}

		function sizeItems() {
			var out = [];
			each(controlsFor(pos), function (el) {
				if (el.tagName === 'SELECT') {
					each(el.options, function (o) { out.push({ value: o.value, select: el }); });
				} else {
					out.push({ value: el.value, input: el });
				}
			});
			return out;
		}

		function matchItem(row) {
			var items = sizeItems(), i;
			for (i = 0; i < items.length; i++) if (String(items[i].value).trim() === String(row[0])) return items[i];
			for (i = 0; i < items.length; i++) if (norm(items[i].value) === norm(row[1])) return items[i];
			for (i = 0; i < items.length; i++) if (norm(items[i].value) === norm(row[0])) return items[i];
			return null;
		}

		function isAvailable(value) {
			var cur = [currentValue(1), currentValue(2), currentValue(3)];
			cur[pos - 1] = value;
			return variants.some(function (v) {
				if (!v.a) return false;
				for (var i = 0; i < v.o.length; i++) {
					if (cur[i] != null && String(cur[i]) !== String(v.o[i])) return false;
				}
				return true;
			});
		}

		function selectItem(item) {
			if (item.input) {
				if (!item.input.checked) item.input.click();
			} else if (item.select) {
				item.select.value = item.value;
				item.select.dispatchEvent(new Event('change', { bubbles: true }));
			}
		}

		function rowFor(value) {
			if (value == null) return null;
			var v = String(value).trim();
			for (var i = 0; i < chart.length; i++) {
				if (String(chart[i][0]) === v || norm(chart[i][1]) === norm(v)) return chart[i];
			}
			return null;
		}

		function updateHint() {
			if (!document.body.contains(root)) return;
			var row = rowFor(currentValue(pos));
			each(rows, function (tr) {
				tr.classList.toggle('is-on', !!row && tr.getAttribute('data-sf-row') === String(row[0]));
			});
			if (!hint) return;
			if (!row) { hint.hidden = true; return; }
			hint.innerHTML = fmt(esc(t.hint), { size: bold(row[0]), eq: bold(row[1]), min: bold(row[2]), max: bold(row[3]) });
			hint.hidden = false;
		}

		function updateWa(h, w) {
			if (!wa || !t.waNumber) return;
			var msg = fmt(t.waMessage, {
				product: t.product,
				height: h || '…',
				weight: w || '…',
				url: location.origin + location.pathname
			});
			wa.href = 'https://wa.me/' + t.waNumber + '?text=' + encodeURIComponent(msg);
		}

		function show(html) { res.innerHTML = html; res.hidden = false; }

		function run() {
			/* EDIT 3: read height only if the field exists */
			var h = hI ? parseInt(hI.value, 10) : 0, w = parseInt(wI.value, 10);
			last.h = hI ? hI.value : '';
			last.w = wI.value;

			if (!(w >= 30 && w <= 200)) { show('<p class="sf__err">' + esc(t.weightErr) + '</p>'); wI.focus(); return; }
			if (h && !(h >= 120 && h <= 220)) { show('<p class="sf__err">' + esc(t.heightErr) + '</p>'); hI.focus(); return; }

			var isShort = !!(h && shortH && h < shortH);
			var idx = -1;
			for (var i = 0; i < chart.length; i++) { if (w <= chart[i][3]) { idx = i; break; } }
			if (idx === -1) idx = chart.length;
			if (isShort) idx++;

			updateWa(h, w);

			if (idx >= chart.length) {
				show('<div class="sf__special">' + esc(t.special).replace(/\n/g, '<br>') + '</div>');
				return;
			}

			var row = chart[idx], item = matchItem(row);
			var label = item ? item.value : row[0] + ' (' + row[1] + ')';
			var notes = isShort ? '<p class="sf__note">' + esc(fmt(t.shortNote, { height: shortH })) + '</p>' : '';
			var btn = '';

			if (item && !isAvailable(item.value)) {
				notes += '<p class="sf__note sf__note--warn">' + esc(t.soldOut) + '</p>';
			} else if (item) {
				btn = '<button type="button" class="sf__pick" data-sf-pick>' + esc(t.pick) + '</button>';
			}

			show('<div class="sf__rec"><small>' + esc(t.result) + '</small><b>' + esc(label) + '</b>' + btn + '</div>' + notes);

			var pick = res.querySelector('[data-sf-pick]');
			if (pick) {
				pick.addEventListener('click', function () {
					var fresh = matchItem(row);
					if (fresh) selectItem(fresh);
					pick.textContent = t.picked;
					pick.disabled = true;
					var atc = scope.querySelector('button[name="add"], form[action*="/cart/add"] [type="submit"]');
					if (atc) atc.scrollIntoView({ behavior: 'smooth', block: 'center' });
				});
			}
		}

		root.querySelector('[data-sf-go]').addEventListener('click', run);
		/* EDIT 4: skip the height field if it doesn't exist */
		[hI, wI].filter(Boolean).forEach(function (el) {
			el.addEventListener('keydown', function (e) {
				if (e.key === 'Enter') { e.preventDefault(); run(); }
			});
		});
		scope.addEventListener('change', function () { setTimeout(updateHint, 0); });

		updateHint();
		updateWa(last.h, last.w);
		if (last.w) run();
	}

	function initAll() { each(document.querySelectorAll('[data-size-finder]'), init); }

	if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll);
	else initAll();
	document.addEventListener('shopify:section:load', initAll);

	/* Re-init if the theme replaces the product HTML after a variant change */
	var timer;
	new MutationObserver(function () {
		clearTimeout(timer);
		timer = setTimeout(initAll, 150);
	}).observe(document.documentElement, { childList: true, subtree: true });
})();